import { render, staticRenderFns } from "./AchievementsAndHonors.vue?vue&type=template&id=209f9bec&scoped=true&"
import script from "./AchievementsAndHonors.vue?vue&type=script&lang=js&"
export * from "./AchievementsAndHonors.vue?vue&type=script&lang=js&"
import style0 from "./AchievementsAndHonors.vue?vue&type=style&index=0&id=209f9bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f9bec",
  null
  
)

export default component.exports